<template>
  <div>
    <x-grid :id="'childGrid'"
            :columns="columns"
            :toolbar-config="toolbarConfig"
            :editable="true"
            ref="grid"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>

      </template>
    </x-grid>
  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridChild'
import {GridChildMixin} from "@/utils/GridChildMixin";

const fac = XGrid.factory;

//列
const columns = [
  fac.makeColumn({
    field: "customerName",
    title: "客户名称",
    width: 100,
    align: 'center',
  }),
  fac.makeColumn({
    field: "name",
    title: "联系人姓名",
    width: 120,
    align: 'center',
  }),
  fac.makeColumn({
    field: "contactPhone",
    title: "联系人手机",
    width: 120,
    align: 'center',
  }),
  fac.makeColumn({
    field: "saleUserName",
    title: "跟进人",
    width: 100,
    align: 'center',
  }),
  fac.makeColumn({
    field: "callonDate",
    title: "跟进时间",
    width: 150,
    align: 'center',
  }),
  fac.makeColumn({
    field: "deptName",
    title: "跟进人部门",
    width: 100,
    align: 'center',
  }),
  fac.makeColumn({
    field: "reportTypeName",
    title: "跟进方式",
    width: 100,
    align: 'center',
  }),
  fac.makeColumn({
    field: "wantStrainName",
    title: "意向品系",
    width: 180,
    align: 'center',
  }),
  fac.makeColumn({
    field: "nextWantLevelName",
    title: "意向等级",
    width: 120,
    align: 'center',
  }),
  fac.makeColumn({
    field: "wantCount",
    title: "预购数量",
    width: 120,
    align: 'center',
  }),
  fac.makeColumn({
    field: "estimateBuyDate",
    title: "预计购车日期",
    width: 160,
    align: 'center',
  }),
  fac.makeColumn({
    field: "reportDesc",
    title: "跟进具体情况",
    width: 160,
    align: 'center',
  }),
  fac.makeColumn({
    field: "customerAttentionName",
    title: "客户关注点",
    width: 160,
    align: 'center',
  }),
  fac.makeColumn({
    field: "dealChanceName",
    title: "成交概率",
    width: 100,
    align: 'center',
  }),
  fac.makeColumn({
    field: "needSupportDesc",
    title: "需要支持事项",
    width: 140,
    align: 'center',
  }),
  fac.makeColumn({
    field: "nextCallonDate",
    title: "下次跟进时间",
    width: 160,
    align: 'center',
  }),
]

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  templatelSlots: 'toolbarBtns'
});

export default {
  mixins: [GridChildMixin],
  data() {
    return {
      columns,
      toolbarConfig,
    }
  }
}
</script>

<style scoped>

</style>
